import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export interface GetNewsArgs {
  locale: string
}

export interface NewsTitleDto {
  data: {
    id: number
    attributes: {
      news_title: string
    }
  }
  meta: Record<string, unknown>
}

export interface NewsDto {
  data: ArticleDto[]
  meta: {
    pagination: {
      start: number
      limit: number
      total: number
    }
  }
}

export interface ArticleDto {
  id: number
  attributes: {
    title: string
    publicated_at: string
    slug: string
    image: MediaObject
    tags: {
      data: TagDto[]
    }
  }
}

export interface TagDto {
  id: number
  attributes: {
    name: string
  }
}

export const getNews = async (
  client: AxiosInstance,
  { locale }: GetNewsArgs,
): Promise<{
  title: string
  news: NewsDto['data']
}> => {
  const homePath = `/home-page`
  const homeParams = {
    locale,
    fields: ['news_title'],
  }
  const newsPath = `/news`
  const newsParams = {
    locale,
    sort: ['publicated_at:desc'],
    fields: ['title', 'publicated_at', 'slug'],
    populate: {
      image: { populate: '*' },
      tags: { fields: ['name'] },
    },
    pagination: {
      start: 0,
      limit: 10,
    },
  }
  const [title, news] = await Promise.all([
    client
      .get<NewsTitleDto>(homePath, { params: homeParams })
      .then(container => container.data.data.attributes.news_title),
    client.get<NewsDto>(newsPath, { params: newsParams }).then(container => container.data.data),
  ])
  return { title, news }
}
